interface EndpointConfig {
  url: string;
  basePath: string;
}

const bobby: EndpointConfig = {
  basePath: '/api',
  url: import.meta.env.VITE_BOBBY_API_URL
};

const cathy: EndpointConfig = {
  basePath: '/v1',
  url: import.meta.env.VITE_DTC_ADMIN_API_URL
};

const apiAccessManagement: EndpointConfig = {
  basePath: '/api/v1',
  url: import.meta.env.VITE_API_ACCESS_MANAGEMENT_API_URL
};

// @TODO probably is not used anymore, we can get rid of it and env var as well
const deviceManagement: EndpointConfig = {
  basePath: '/api/v1',
  url: import.meta.env.VITE_API_DEVICE_MANAGEMENT_URL
};

const dataGateway: EndpointConfig = {
  basePath: '/api/v1/backoffice',
  url: import.meta.env.VITE_DATA_GATEWAY_API_URL
};

const tourCommander: EndpointConfig = {
  basePath: '/v1',
  url: import.meta.env.VITE_TOUR_COMMANDER_API_URL
};

const liveIssuesMonitoring: EndpointConfig = {
  basePath: '',
  url: import.meta.env.VITE_LIVE_ISSUES_MONITORING_URL
};

const jobCenter: EndpointConfig = {
  basePath: '',
  url: import.meta.env.VITE_JOB_CENTER_API_URL
};

const bekki: EndpointConfig = {
  basePath: '/chat',
  url: import.meta.env.VITE_BEKKI_API_URL ?? ''
};

export {
  apiAccessManagement,
  bekki,
  bobby,
  cathy,
  dataGateway,
  deviceManagement,
  jobCenter,
  liveIssuesMonitoring,
  tourCommander
};
